module.exports = __webpack_public_path__ + "static/media/img10.dbb733f6.jpg";